import * as React from 'react';
import { useSelector } from 'react-redux';
import { Entity, SecurityAction } from 'gossamer-unified';
import { isAllowed, selectUser, UserState } from '../data/ReduxUser';

interface IsAllowedProps {
  action: SecurityAction;
  children?: React.ReactNode;
  entity: Entity<any>;
  special?: string;
}

export const IsAllowed = (props: IsAllowedProps): React.JSX.Element => {
  const user = useSelector(selectUser);
  if (!user || !isAllowed(props.entity, props.action, user, props.special)) {
    return <></>;
  }
  return <>{props.children}</>;
};
